var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76857 11.6759L0.146076 6.77323C-0.048692 6.56685 -0.048692 6.23343 0.146076 6.02651L4.76857 1.12381C5.04973 0.825227 5.50719 0.825227 5.78885 1.12381C6.07002 1.42239 6.07002 1.90697 5.78885 2.20555L1.83456 6.40014L5.78885 10.5937C6.07002 10.8928 6.07002 11.3774 5.78885 11.6759C5.50719 11.9745 5.04973 11.9745 4.76857 11.6759Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.e9760f3e9672854ee27bda45d408328f.svg";
export { ForwardRef as ReactComponent };